import React, { memo } from 'react';
import CampaignHeader from '../../shared/CampaignHeader';
import CampaignProgressMeta from '../../shared/CampaignHeader/components/CampaignProgressMeta';

/**
 * TodoListHeader Component
 * 
 * Uses the shared CampaignHeader component for breadcrumb, icon, and title.
 * Adds TodoList-specific progress bar with shine effect.
 */
const TodoListHeader = memo(({
  campaignName,
  campaignIcon,
  campaignProgress,
  breadcrumbPath = [],
  completedCount,
  totalCount,
  remainingMinutes = 0,
  remainingMinMinutes,
  missingEstCount = 0,
  remainingBreakdown = [],
  onSelectSprint,
  onSprintIconChange,
  onRenameSprint,
}) => {
  if (!campaignName) return null;

  return (
    <CampaignHeader
      name={campaignName}
      icon={campaignIcon}
      breadcrumbPath={breadcrumbPath}
      onRename={onRenameSprint}
      onIconChange={onSprintIconChange}
      onSelectSprint={onSelectSprint}
      classPrefix="todolist-header"
    >
      {/* TodoList-specific progress bar with shine effect */}
      <div className="todolist-header__progress-row">
        <div className="todolist-header__progress-track">
          <div
            className="todolist-header__progress-fill"
            style={{ width: `${campaignProgress}%` }}
          >
            <div className="todolist-header__progress-shine" />
          </div>
        </div>
        <span className="todolist-header__progress-text">{campaignProgress}%</span>
      </div>
      
      {/* Task count meta */}
      <CampaignProgressMeta
        completedCount={completedCount}
        totalCount={totalCount}
        remainingMinutes={remainingMinutes}
        remainingMinMinutes={remainingMinMinutes}
        missingEstCount={missingEstCount}
        remainingBreakdown={remainingBreakdown}
        className="todolist-header__meta"
        countClassName="todolist-header__meta-count"
      />
    </CampaignHeader>
  );
});

TodoListHeader.displayName = 'TodoListHeader';

export default TodoListHeader;
